import { render } from "./ArrowBackIcon.vue?vue&type=template&id=34c07ebf"
import script from "./ArrowBackIcon.vue?vue&type=script&lang=js"
export * from "./ArrowBackIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vdzeer/Projects/movesmart-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__